@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';

dialog {
  transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: var(--radius-lg, 16px) var(--radius-lg, 16px) 0px 0px;
  background: var(--neutral-background-primary, #FFF);
  box-shadow: 0px 0px 56px 0px rgba(0, 0, 0, 0.29);
  position: fixed;
  bottom: 0;
  top: auto !important;
  left: 0;
  right: 0;
  margin: 0;
  height: auto;
}
.dialog-overlay {
  padding: 0;
  border: 0;
  margin: 0;
  width: 100%;
  max-width: 100%;
  max-height: 80vh;
  position: static;
  height: auto !important;
}

.dialog-flyout {
  visibility: hidden;
  position: absolute;
  right: 0;
  z-index: 100;
  opacity: 0;
  transition: all 200ms ease-in-out;
  &--open {
    display: block;
    opacity: 1;
    visibility: visible;
  }
}
.dialog-surface {
  position: relative;
  background-color: rgb(255, 255, 255);
  padding-top: 20px;
  padding-bottom: 24px;
  box-shadow: rgba(0, 0, 0, 0.21) 0px 13px 37px;
  border-radius: 0px;
  box-sizing: border-box;
  max-width: 100%;
  margin: 0 auto;
  overflow-y: auto;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  @include breakpoint('md','lg','xl') {
    border-radius: 8px;
    padding: 16px 0;
  }
  .dialog-header {
    .dialog-title {
      font-size: 18px;
      margin: 0px;
      letter-spacing: 0px;
      font-family: $typography-family-sans;
      font-weight: 700;
      font-size: 20px;
      line-height: 1.25;
      padding: 0 24px;
      @include breakpoint('md','lg','xl') {
        padding: 0 1rem;
      }
    }
    .dialog-close {
      float: right;
      padding-right: 8px;
      margin-top: calc(-12px);
      display: inline-flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: center;
      justify-content: center;
      position: relative;
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;
      cursor: pointer;
      user-select: none;
      vertical-align: middle;
      appearance: none;
      text-align: center;
      color: rgb(24, 24, 24);
      font-size: 24px;
      width: 40px;
      height: 40px;
      background-color: transparent;
      outline: 0px;
      border-width: 0px;
      border-style: initial;
      border-color: initial;
      border-image: initial;
      text-decoration: none;
      flex: 0 0 auto;
      border-radius: 50%;
      overflow: visible;
      transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1);
      padding: 12px;
      .dialog-close-icon {
        user-select: none;
        width: 1em;
        height: 1em;
        display: inline-block;
        fill: currentcolor;
        flex-shrink: 0;
        font-size: inherit;
        transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1);
      }
      @include breakpoint('md','lg','xl') {
        display: none;
      }
    }
  }
  .dialog-content{
    padding: 8px 24px 8px;
    flex: 1 1 auto;
    overflow-y: auto;
    @include breakpoint('md','lg','xl') {
      padding: 0.5rem 1rem;
    }
  }

  .dialog-actions {
    display: flex;
    flex-direction: column;
    -webkit-box-pack: start;
    justify-content: flex-start;
    flex: 0 0 auto;
    gap: 8px;
    padding: 0 24px;
    @include breakpoint('md','lg','xl') {
      padding: 0 1rem;
    }
  }
}
